import React from "react";
import { IconProps } from "../icon";
import { createIcon } from "../util/create-icon";
// import "../style/css";

const InfoCircleIcon: React.ForwardRefExoticComponent<
  IconProps & React.RefAttributes<SVGSVGElement>
> = /*#__PURE__*/ createIcon(
  "info-circle",
  "InfoCircleIcon",
  ["currentColor","white"],
  (colorList) => <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><g fill="none"><g clipPath="url(#clip0_19498_1550)"><path d="M8.00016 14C11.3139 14 14.0002 11.3137 14.0002 8.00004C14.0002 4.68633 11.3139 2.00004 8.00016 2.00004C4.68646 2.00004 2.00016 4.68633 2.00016 8.00004C2.00016 11.3137 4.68645 14 8.00016 14ZM15.3335 8.00004C15.3335 12.0501 12.0503 15.3334 8.00016 15.3334C3.95008 15.3334 0.66683 12.0501 0.666831 8.00004C0.666831 3.94995 3.95008 0.666707 8.00016 0.666707C12.0503 0.666708 15.3335 3.94995 15.3335 8.00004ZM7.3335 11.6667L7.3335 6.66671L8.66683 6.66671L8.66683 11.6667L7.3335 11.6667ZM8.66683 5.66671L7.33089 5.66671L7.33089 4.33077L8.66683 4.33077L8.66683 5.66671Z" fill={colorList[0]} fillRule="evenodd" clipRule="evenodd" fillOpacity="0.9"/></g><defs><clipPath id="clip0_19498_1550"><rect width="16" height="16" fill={colorList[1]}/></clipPath></defs></g></svg>
);

export default InfoCircleIcon;
